/* eslint-disable */
import React from 'react';
import { Provider } from 'react-redux';
import Loading from '../Components/Loading/Loading.component';
import Theme from '../Components/Theme/Theme.component';
import EntriesContext from '../Contexts/Entries/Entries.context';
import ServicesContext from '../Contexts/Services/Services.context';
import createStore from '../State/CreateStore';
import AppPropTypes from './App.props';

/**
 * AppComponent
 * @export
 * @class AppComponent
 * @extends {React.Component<AppComponentComposedProps, AppComponentState>}
 */
export class AppComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<AppComponentProps>}
   * @memberof AppComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`App`}
   * @memberof AppComponent
   */
  static displayName = `App`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof AppComponent
   */
  static propTypes = AppPropTypes;

  /**
   * Data specific to the `<AppComponent />` instance
   * @type {AppComponentState}
   * @memberof AppComponent
   */
  state = {};

  /**
   * Render AppComponent
   * @returns {React.Component} AppComponent
   * @memberof AppComponent
   */
  render() {
    const { children, entry, history, services } = this.props;
    const { store, persistor } = createStore(services, entry, history);
    return (
      <Provider store={store}>
        <ServicesContext.Provider value={{ ...services, storeService: { ...store } }}>
          <EntriesContext.Provider value={entry}>
            <Loading history={history} persistor={persistor}>
              <Theme>{children}</Theme>
            </Loading>
          </EntriesContext.Provider>
        </ServicesContext.Provider>
      </Provider>
    );
  }
}

/** @type {React.ComponentClass<AppComponentProps>} */
const App = AppComponent;

export default App;
